import { t } from 'i18next'
import { cloneDeep } from 'lodash'
import React, { useEffect, useState } from 'react'
import { Alert, Spinner } from 'react-bootstrap'
import { MdLibraryAdd } from 'react-icons/md'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import { useActivitiesState } from '../../../stores/Configuration/ActivitiesProvider'
import { useContingentTemplatesState } from '../../../stores/Configuration/ContingentTemplatesProvider'
import { emptyGuid } from '../../../utils/emptyGuid'
import { setValueByKey } from '../../../utils/utils'
import { ButtonWithLoadingState } from '../../Buttons'
import ActivityRow from './ActivityRow'
import StyledAddRowButton from '../../Buttons/StyledAddRowButton'
import { ErrorAlerts } from '../../../utils/api/makeCall'

const StyledWrapper = styled.div`
  max-width: 660px;
  @media (max-width: 1080px) {
    max-width: none;
  }
`
const activityAssignmentTemplate = [
  {
    activityLevel: {
      startValue: '0',
      endValue: '100',
      includeStartValue: true,
      includeEndValue: true,
    },
    activityId: emptyGuid,
  },
]

const ContingentTemplateActivites = () => {
  const {
    assignedActivities,
    setAssignedActivities,
    loadingStates,
    patchContingentTemplate,
    assignedActivitiesHasChanged,
    errorStates,
    resetStates,
    successStates,
  } = useContingentTemplatesState()
  const { activities } = useActivitiesState()
  const { contingentTemplateId } = useParams()
  const [
    errorMessageDuplicateRelatedActivity,
    setErrorMessageDuplicateRelatedActivity,
  ] = useState(false)

  useEffect(() => {
    return () => resetStates()
  }, [resetStates])

  const updateItem = (index) => (e) => {
    let itemToChange = cloneDeep(assignedActivities)[index]
    let key = e.target.name
    let value = null

    if (e.target.type === 'checkbox') {
      value = e.target.checked
    } else if (e.target.type === 'number') {
      value = parseInt(e.target.value)
    } else {
      value = e.target.value
    }

    setAssignedActivities((prev) => {
      const newValues = [...prev]
      newValues[index] = setValueByKey(key, value, itemToChange)
      return newValues
    })
  }
  const updateItemWithDuplicateCheck = (index) => (e) => {
    const selectedValue = e.target.value
    const isDuplicate = assignedActivities.some(
      (a, i) => a.activityId === selectedValue && i !== index
    )

    if (isDuplicate) {
      setErrorMessageDuplicateRelatedActivity(true)
    } else {
      setErrorMessageDuplicateRelatedActivity(false)
      updateItem(index)(e)
    }
  }

  const deleteItem = (index) => {
    setAssignedActivities((prev) => {
      const newValues = [...prev]
      newValues.splice(index, 1)
      return newValues
    })
  }

  const addRow = () => {
    setAssignedActivities((prev) => [...prev, ...activityAssignmentTemplate])
  }

  const handleSubmit = () => {
    patchContingentTemplate(contingentTemplateId)
    setErrorMessageDuplicateRelatedActivity(false)
  }
  return (
    <StyledWrapper>
      {loadingStates.getContingentTemplate ? (
        <div className='d-flex justify-content-center'>
          <Spinner animation='border' variant='primary' />
        </div>
      ) : (
        assignedActivities.map((item, index) => {
          return (
            <ActivityRow
              item={item}
              updateItem={updateItemWithDuplicateCheck(index)}
              deleteItem={() => deleteItem(index)}
              activities={activities}
              index={index}
              key={`ac_${index}`}
              formErrors={errorStates?.saveContingentTemplate?.formErrors}
            />
          )
        })
      )}
      {assignedActivitiesHasChanged && (
        <Alert variant='info' className='mt-3'>
          {t('contingentTemplates:activitiesModified')}
        </Alert>
      )}
      {errorMessageDuplicateRelatedActivity && (
        <Alert variant='danger' className='mt-3'>
          {t('contingentTemplates:errorMessageDuplicateRelatedActivity')}
        </Alert>
      )}
      {successStates.saveContingentTemplate && (
        <Alert variant='success' className='my-2'>
          {t('registrationBox:savingSuccess')}
        </Alert>
      )}
      <div className='mt-2'>
        <ErrorAlerts errorStates={errorStates} />
      </div>
      <div className='d-flex justify-content-between mt-3'>
        <ButtonWithLoadingState
          disabled={!assignedActivitiesHasChanged}
          buttonText={t('saveButton')}
          isLoading={loadingStates.saveContingentTemplate}
          onClick={handleSubmit}
        />
        <StyledAddRowButton variant='secondary' onClick={addRow}>
          <MdLibraryAdd className='me-3' />
          {t('contingentTemplates:addActivityAssignment')}
        </StyledAddRowButton>
      </div>
    </StyledWrapper>
  )
}

export default ContingentTemplateActivites
